@if (aplicaciones.isLoading() && !aplicaciones.hasValue()) {
  <div class="seg-vacio" role="status">
    <mat-icon>hourglass_empty</mat-icon>
    <p>Buscando las aplicaciones de perfil…</p>
  </div>
} @else if (aplicaciones.error()) {
  <div class="seg-vacio seg-vacio--error" role="alert">
    <mat-icon>error_outline</mat-icon>
    <p>No se pudieron traer las aplicaciones de perfil.</p>
  </div>
} @else {
  <div
    class="seg-kpis"
    role="list"
    aria-label="Resumen de aplicaciones de perfil"
  >
    @for (k of kpis(); track k.etiqueta) {
      <div class="seg-kpis__item" role="listitem" [matTooltip]="k.ayuda">
        <app-stat-card
          [title]="k.etiqueta"
          [value]="k.valor"
          [icon]="k.icono"
          [color]="k.color"
          [formatAsNumber]="true"
        ></app-stat-card>
      </div>
    }
  </div>

  <div class="seg-barra">
    @if (fuente()) {
      <span class="seg-filtro-fuente">
        <mat-icon>filter_alt</mat-icon>
        Sólo lo mandado desde {{ nombreFuente() }}
        <a
          class="irx-enlace"
          routerLink="/main/luminarias/seguimiento/perfiles"
          [queryParams]="{ hijos: hijos() ? null : '0' }"
        >
          ver todas
        </a>
      </span>
    }
    <p class="seg-pista">
      <mat-icon>info</mat-icon>
      <span>
        Cada acción que cambió el perfil de alguna luminaria: asignarlo,
        editarlo, reaplicarlo o desvincular lo que lo daba. Cuentan sólo las
        luminarias a las que se les tuvo que mandar algo.
      </span>
    </p>
    <div class="seg-crece"></div>
    @if (puedeVerHijos) {
      <mat-slide-toggle
        color="primary"
        [checked]="hijos()"
        (change)="cambiarHijos($event.checked)"
        matTooltip="Suma lo de los clientes hijos y muestra de qué cliente es cada acción."
      >
        Datos de mis clientes
      </mat-slide-toggle>
    }
    <button
      irxBoton="secundario"
      type="button"
      (click)="recargar()"
      [disabled]="aplicaciones.isLoading()"
    >
      <mat-icon>refresh</mat-icon>
      Actualizar
    </button>
  </div>

  @if (!enCurso().length && !terminadas().length) {
    <div class="seg-calma">
      <mat-icon>task_alt</mat-icon>
      <span>
        No se mandó ningún perfil en los últimos {{ dias }} días. Aparece acá en
        cuanto se asigna, edita o reaplica uno.
      </span>
    </div>
  }

  @if (enCurso().length) {
    <h2 class="seg-seccion">
      En curso
      <span class="seg-seccion__cuenta">{{ enCurso().length | number }}</span>
    </h2>
    <div class="seg-fichas">
      @for (f of enCurso(); track f.r.id) {
        <ng-container
          *ngTemplateOutlet="ficha; context: { $implicit: f }"
        ></ng-container>
      }
    </div>
  }

  @if (terminadas().length) {
    <h2 class="seg-seccion">
      Terminadas
      <span class="seg-seccion__cuenta">
        {{ terminadas().length | number }}
      </span>
    </h2>
    <div class="seg-fichas">
      @for (f of terminadas(); track f.r.id) {
        <ng-container
          *ngTemplateOutlet="ficha; context: { $implicit: f }"
        ></ng-container>
      }
    </div>
  }

  <p class="seg-pista seg-pista--pie">
    <mat-icon>info</mat-icon>
    <span>
      Se muestran las acciones de los
      <strong>últimos {{ dias }} días</strong>
      y, si una acción posterior le cambió el perfil a una luminaria, esa
      luminaria pasa a contarse en la acción nueva.
    </span>
  </p>
}

<ng-template #ficha let-f>
  <a
    class="irx-enlace seg-ficha"
    [style.--tono]="f.tono"
    [routerLink]="['/main/luminarias/seguimiento/perfiles', f.r.id]"
    [queryParams]="{ hijos: hijos() ? null : '0' }"
  >
    <span class="seg-ficha__icono" [matTooltip]="f.motivoDetalle">
      <mat-icon>{{ f.icono }}</mat-icon>
    </span>

    <div class="seg-ficha__cuerpo">
      <div class="seg-ficha__titulo">
        <h3>{{ f.titulo }}</h3>
        <span class="seg-chip" [style.--tono]="f.tono">
          <mat-icon>{{ f.iconoEstado }}</mat-icon>
          {{ f.estado }}
        </span>
      </div>
      <p class="seg-ficha__objetivo">
        {{ f.r.total | number }}
        {{ f.r.total === 1 ? 'luminaria' : 'luminarias' }} · {{ f.motivo }}
        @if (hijos() && !f.sinMarca && f.cliente) {
          ·
          <span [matTooltip]="f.jerarquia">{{ f.cliente }}</span>
        }
        @if (f.quien) {
          · {{ f.quien }}
        } @else if (!f.sinMarca) {
          · automática
        }
      </p>

      <div
        class="seg-barra-avance"
        role="img"
        [attr.aria-label]="f.porcentaje + ' por ciento con el perfil'"
      >
        @for (s of SEGMENTOS; track s.clave) {
          @if (f.a[s.clave]) {
            <span
              [style.width.%]="ancho(f, s.clave)"
              [style.background]="s.tono"
            ></span>
          }
        }
      </div>

      <ul class="seg-leyenda">
        @for (s of SEGMENTOS; track s.clave) {
          @if (f.a[s.clave]) {
            <li [matTooltip]="s.ayuda">
              <span class="seg-punto" [style.background]="s.tono"></span>
              <strong>{{ f.a[s.clave] | number }}</strong>
              {{ s.etiqueta }}
            </li>
          }
        }
      </ul>
    </div>

    <div class="seg-ficha__cifras">
      <span
        class="seg-porcentaje"
        matTooltip="Sobre las luminarias a las que se les mandó el perfil en esta acción."
      >
        {{ f.porcentaje }}
        <small>%</small>
      </span>
      @if (f.r.aplicacion; as a) {
        <span class="seg-fecha">{{ fecha(a.fecha) }}</span>
        <span class="seg-hace">{{ cuando(a.fecha) }}</span>
      } @else {
        <span class="seg-hace">Sin fecha de inicio</span>
      }
    </div>

    <mat-icon class="seg-ficha__ir">chevron_right</mat-icon>
  </a>
</ng-template>
